@if (isLoadingData) {
    <div class="flex justify-center">
        <p-progress-spinner ariaLabel="loading" />
    </div>
}
@else {
    <div class="grid grid-cols-3 gap-2">
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="number" suffix=" cm" label="Longueur" property="longueur" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="number" suffix=" cm" label="Largeur" property="largeur" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product"  type="number" suffix=" cm" label="Hauteur" property="hauteur" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="text" label="N° Carton" property="numero_carton" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="number" suffix=" kg" label="Poids" property="poids" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
    </div>
}